import StoreDetailsInfoContainer from 'components/Store/StoreDetailsInfoContainer'
import { LoadingOverlay } from 'LoadingOverlay'
import PropTypes from 'prop-types'
import React from 'react'
import { emptyArray } from 'utils'

import Box from '@mui/material/Box'

const SearchDetails = ({ details, detailsFetching, store }) => (
  <Box className="search-details">
    <Box className="flex-row">
      <Box className="search-details_name">
        {details.storeName} {details.storeId}
      </Box>
    </Box>

    <LoadingOverlay isLoading={detailsFetching}>
      <StoreDetailsInfoContainer
        countryId={details.countryId || store.countryId}
        details={{
          ...details,
          results: details?.results || emptyArray,
        }}
        exposTimestamp={store.exposTimestamp}
        resaTimestamp={store.resaTimestamp}
        trafficTimestamp={store.trafficTimestamp}
      />
    </LoadingOverlay>
  </Box>
)

SearchDetails.propTypes = {
  details: PropTypes.object,
  detailsFetching: PropTypes.bool,
  store: PropTypes.object,
}

export default SearchDetails
